import {
  buildQueryString,
  useFilteredObjects,
  useObject,
  useObjects,
  usePagination,
} from "../../base";
import { usePaginationCount } from "../../base/hooks/retrieve";

import {
  getAll,
  performFilter,
  filterPagination,
  getSingle,
} from "../store/actions";

import constants from "../store/constants";

export function useEditabledoc(id) {
  const params = {
    storeName: constants.STORE_NAME,
    id: id,
    fetchMethod: getSingle,
  };

  return useObject(params);
}

export function useEditabledocs(filterMethod) {
  const params = {
    storeName: constants.STORE_NAME,
    filterMethod: filterMethod,
    fetchMethod: getAll,
  };
  return useObjects(params);
}

export function useFilteredEditabledocs(querystring) {
  const params = {
    storeName: constants.STORE_NAME,
    fetchMethod: performFilter,
    querystring: querystring,
  };

  return useFilteredObjects(params);
}

export function useEditabledocPagination(querystring) {
  const params = {
    storeName: constants.STORE_NAME,
    fetchMethod: filterPagination,
    querystring: querystring,
  };

  return usePagination(params);
}

export function useEditableDocPaginationCount({ filters = {} }) {
  const queryString = buildQueryString({
    _page: 1,
    _page_size: 0,
    is_template: true,
    ...filters,
  });

  const params = {
    storeName: constants.STORE_NAME,
    fetchMethod: filterPagination,
    querystring: queryString,
  };

  return usePaginationCount(params);
}
